import { Link } from "react-router-dom";

/**
 * What to do when there is no run to show.
 *
 * "Run an analysis first." was accurate and useless: it named the missing thing
 * without saying how to get it, on a screen someone reached by clicking a tab
 * that looked available. This names the next action and links to it, and offers
 * the sample pair for anyone who has no export files of their own.
 */
export function NoAnalysis({ what }: { what: string }) {
  return (
    <div className="space-y-2 p-6" data-testid="no-analysis">
      <p className="text-sm text-slate-700">
        No run is loaded, so there is no {what} to show.
      </p>
      <p className="text-sm text-slate-600">
        Load a reference and a candidate export on the{" "}
        <Link className="text-sky-700 underline" to="/">
          upload page
        </Link>{" "}
        and run the analysis. No files to hand? <strong>Try with sample data</strong> there loads two
        real runs of one source.
      </p>
    </div>
  );
}
